// @flow
import styled from 'styled-components';
import { Link } from "react-router-dom";

import colors from '../../assets/css/colors';

export const ButtonPrimary = styled.button`
	outline: none;
	background: ${({ inverted }) => inverted ? colors.nrlGreen : colors.nrlDarkGreen};
	border: 1px solid ${({ inverted }) => inverted ? colors.nrlGreen : colors.nrlDarkGreen};
	color: ${({ inverted }) => inverted ? colors.nrlDarkGreen : colors.nrlGreen};
	border-radius: 3px;
	font-weight: bold;
	font-size: 12px;
	letter-spacing: 0.5px;
	line-height: 1.2;
	padding: 10px;
	cursor: pointer;
	width: ${({ width }) => width || 'auto'};
	text-transform: uppercase;
	transition: all 0.15s linear;

	&:hover {
		background: ${({ inverted }) => inverted ? colors.nrlGreenHover : colors.nrlDarkGreenHover};
	}

	&:disabled {
		background: ${colors.lightGreen};
		color: #fff;
		border-color: ${colors.lightGreen};
	}
`;

ButtonPrimary.displayName = "ButtonPrimary";

export const ButtonPrimaryLink = styled(ButtonPrimary.withComponent(Link))`
	display: flex;
	align-items: center;
    justify-content: center;
	text-decoration: none;
`;

ButtonPrimaryLink.displayName = "ButtonPrimaryLink";

export default ButtonPrimary;


// WEBPACK FOOTER //
// ./src/components/ButtonPrimary/index.js